'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ConfigurationDiscontinuedRoutesController = function ConfigurationDiscontinuedRoutesController($scope, $log, $q, dataRetrieverService, dataRetrieverConstantsService, cellLinkRendererFactory, configurationDiscontinuedRoutesService, discontinuedRoutesRendererFactory, configurationService) {
  var CONFLICT_ERROR_CODE = 409;
  dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SYSTEM_STATUS_SCREEN, dataRetrieverConstantsService.SYSTEM_STATUS_CONFIGURATION_DISCONTINUED_ROUTES_MODE).setCustomSearchCriteriaRules([]);
  $scope.customRenderers = _.assign({}, cellLinkRendererFactory, discontinuedRoutesRendererFactory);
  $scope.selectedRows = [];
  $scope.showDeleteModal = false;
  function getDiscontinuedRouteKey(row) {
    return row.route.replace(' (all) ', '-') + '-' + row.departureDateRangeStart.toISOString() + (row.departureDateRangeEnd ? '-' + row.departureDateRangeEnd.toISOString() : '');
  }
  function validateSingleRow(row, markets) {
    var route = JSON.stringify(row.route);
    if (_.isEmpty(row.route)) {
      $scope.validationErrorMessage = '"Route" cannot be empty.';
      return false;
    }
    if (_.isEmpty(row.connectingServices)) {
      $scope.validationErrorMessage = '"Connections" cannot be empty for route: ' + row.route + '.';
      return false;
    }
    if (_.isEmpty(row.departureDateRangeStart)) {
      $scope.validationErrorMessage = '"Start Date" cannot be empty for route: ' + row.route + '.';
      return false;
    }
    if (!_.isEmpty(row.departureDateRangeEnd) && row.departureDateRangeEnd.isBefore(row.departureDateRangeStart)) {
      $scope.validationErrorMessage = '"End Date" cannot be before "Start Date" for route: ' + row.route + '.';
      return false;
    }
    if (route.replace(' (all) ', '-').split('-').length > 2 && row.connectingServices != 'N/A') {
      $scope.validationErrorMessage = 'Only "N/A" option is applicable for route: ' + row.route + '.';
      return false;
    }
    _.each(row.discontinuedSegments, function (segment) {
      var matchingOrigin = _.filter(markets, function (market) {
        return market.origin === segment.origin;
      }).length;
      var matchingDestination = _.filter(markets, function (market) {
        return market.destination === segment.destination;
      }).length;
      if (matchingOrigin === 0) {
        $scope.validationErrorMessage = '"Origin": ' + segment.origin + ' from route: ' + row.route + ' is not correct.';
        return false;
      }
      if (matchingDestination === 0) {
        $scope.validationErrorMessage = '"Destination": ' + segment.destination + ' from route: ' + row.route + ' is not correct.';
        return false;
      }
    });
  }
  $scope.detectDuplicates = function (gridData) {
    var duplicateDetection = {};
    _.each(gridData, function (row) {
      var key = getDiscontinuedRouteKey(row);
      if (duplicateDetection[key]) {
        $scope.validationErrorMessage = 'Duplicated records exist for route: ' + row.route.replace(' (all) ', '-') + '.';
        return false;
      } else {
        duplicateDetection[key] = true;
      }
    });
  };
  $scope.customSaveValidation = function (rows, gridData) {
    var markets = configurationService.getMarkets();
    $scope.validationErrorMessage = '';
    _.each(rows, function (row) {
      return validateSingleRow(row, markets);
    });
    if (_.isEmpty($scope.validationErrorMessage)) {
      $scope.detectDuplicates(gridData);
    }
    return _.isEmpty($scope.validationErrorMessage);
  };
  $scope.customErrorMessage = function () {
    return $scope.validationErrorMessage;
  };
  $scope.customSave = function (rows) {
    return configurationDiscontinuedRoutesService.save(rows)["catch"](postColumnsErrorHandler).then(function () {
      $scope.$broadcast('grid:dataChanged');
    });
  };
  function postColumnsErrorHandler(response) {
    if (response.status === CONFLICT_ERROR_CODE) {
      $log.error('ConfigurationDiscontinuedRoutesController: postColumnsErrorHandler - Duplicate record exists');
      toastr.error('Duplicated records exist.<br>Please correct data before saving.');
    } else {
      var errorMsg = 'Error when updating configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
      $log.error('ConfigurationDiscontinuedRoutesController: postColumnsErrorHandler - ' + errorMsg);
      toastr.error(errorMsg);
    }
    return $q.reject();
  }
  function getSegmentsFromRoute(routeElements) {
    var segments = [];
    var currSegment = {
      origin: ''
    };
    _.each(routeElements, function (value) {
      if (currSegment.origin === '') {
        currSegment.origin = value;
      } else if (value.match(/^\d{1,4}/)) {
        currSegment.number = parseInt(value);
      } else {
        currSegment.destination = value;
        segments.push(_.clone(currSegment));
        currSegment = {
          origin: value
        };
      }
    });
    return segments;
  }
  $scope.onCellEditHandler = function (gridData, rowId, colName) {
    if (colName !== 'route') {
      return;
    }
    var rowData = gridData[rowId];
    var route = rowData.route.replace(' (all) ', '-');
    var routeElements = route.split('-');
    rowData.origin = _.first(routeElements);
    rowData.destination = _.last(routeElements);
    rowData.discontinuedSegments = getSegmentsFromRoute(routeElements);
    return {
      ids: [rowId],
      fieldNames: ['origin', 'destination']
    };
  };
  $scope.customRemove = function (rowsToBeRemoved) {
    $scope.selectedRows = rowsToBeRemoved;
    $scope.showDeleteModal = true;
    return false;
  };
  $scope.removeDiscontinuedRoutes = function () {
    return configurationDiscontinuedRoutesService.remove($scope.selectedRows)["catch"](postColumnsErrorHandler).then(function () {
      $scope.$broadcast('grid:dataChanged');
    });
  };
  $scope.makeExportToCsv = function (data) {
    if (!data.length) {
      toastr.warning('No discontinued routes to export');
      return;
    }
    configurationDiscontinuedRoutesService.exportToCsv(data);
  };
};
ConfigurationDiscontinuedRoutesController.$inject = ['$scope', '$log', '$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'CellLinkRendererFactory', 'ConfigurationDiscontinuedRoutesService', 'DiscontinuedRoutesRendererFactory', 'ConfigurationService'];
module.exports = ConfigurationDiscontinuedRoutesController;